module.exports = __webpack_public_path__ + "media/images/home/main/aa/11-0308b5549cd0aa490d2751e9403c538f.png";